import { Button } from '@verlo/shared/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@verlo/shared/components/ui/dialog';

const EditCoversDialog = ({
  open,
  onOpenChange,
  covers,
  maxCapacity,
  onCoversChange,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size="confirm">
        <DialogHeader>
          <DialogTitle>Update Covers</DialogTitle>
        </DialogHeader>
        <div className="flex items-center justify-center gap-6 py-6">
          <Button
            variant="outline"
            size="icon"
            className="h-12 w-12"
            onClick={() => onCoversChange(Math.max(1, covers - 1))}
            disabled={covers <= 1}
          >
            -
          </Button>
          <span className="text-4xl font-bold w-16 text-center">{covers}</span>
          <Button
            variant="outline"
            size="icon"
            className="h-12 w-12"
            onClick={() => onCoversChange(Math.min(maxCapacity, covers + 1))}
            disabled={covers >= maxCapacity}
          >
            +
          </Button>
        </div>
        <p className="text-center text-sm text-ink-soft">Max capacity: {maxCapacity}</p>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button className="bg-verlo hover:bg-verlo-hover" onClick={onConfirm}>
            Update Covers
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default EditCoversDialog;
